import "./Products.css";
import React, { useState } from "react";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTestDrive } from "../../context/TestDriveContext"; // ✅ ADDED

const ProductCard = ({ product }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const { openPopup } = useTestDrive(); // ✅ ADDED

  const handleExplore = () => {
    navigate("/explore", {
      state: { id: product.id },
    });
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) =>
      prev === 0 ? product.allImages.length - 1 : prev - 1
    );
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) =>
      prev === product.allImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="product-card-ui">
      <div className="top-row">
        <span className="badge">3 YEARS WARRANTY 🏅</span>

        <div className="rating">
          <span>Rating</span>
          <div className="stars">
            {"★".repeat(product.rating)}
            {"☆".repeat(5 - product.rating)}
          </div>
        </div>
      </div>

      <div className="image-wrapper">
        <button className="nav-btn left" onClick={handlePrev}>
          <FaChevronLeft />
        </button>

        <div className="image-container">
          <img src={product.allImages[currentIndex]} alt={product.name} />
        </div>

        <button className="nav-btn right" onClick={handleNext}>
          <FaChevronRight />
        </button>

        <div className="spec-circle range">
          <strong>{product.range}</strong>
          <span>RANGE</span>
        </div>

        <div className="spec-circle speed">
          <strong>{product.speed}</strong>
        </div>
      </div>

      <div className="colors">
        <span>Available Colors</span>
        <div className="color-dots">
          {product.colors.map((c, i) => (
            <span key={i} style={{ background: c }}></span>
          ))}
        </div>
      </div>

      <div className="details">
        <h2>{product.name}</h2>
        <div className="price">
          <span>FROM</span>
          <strong>{product.price}</strong>
        </div>
      </div>

      <div className="actions">
        <button className="explore" onClick={handleExplore}>
          Explore <FaArrowRight />
        </button>

        {/* ✅ FIXED */}
        <button className="test" onClick={openPopup}>
          Test Ride 🛵
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
